import { TMStageId } from './../../entities/tm/TMStageResponse';
import { TMStageAPI } from '@business/api/tm';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';
import { TMStageResponse } from '@business/entities/tm';
import { TMBoardId } from '@business/entities/tm/TimeMaterialBoardResponse';

export class TmStageBloc extends BaseBloc {
  private readonly ordersRepo = new Repository<TMStageResponse>({
    getItemId: brand => brand.id,
  });

  readonly stages$ = this.ordersRepo.items$.pipe(
    map(items => R.sortBy(items, 'menuOrder')),
    map(items => R.filter(items, i => i.active)),
  );
  readonly all$ = this.ordersRepo.items$.pipe(map(items => R.sortBy(items, 'menuOrder')));

  onReset() {
    this.ordersRepo.reset();
  }

  fetchStages = (boardId: TMBoardId) => {
    return TMStageAPI.fetchStages(boardId).pipe(this.ordersRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_order_stages_error') }));
  };

  fetchStage = (id: TMStageId) => {
    return TMStageAPI.fetchStage(id).pipe(
      this.ordersRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_order_stages_error') }),
    );
  };

  createStage = (brand: Partial<TMStageResponse>) => {
    return TMStageAPI.createStage(brand).pipe(
      this.ordersRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_order_stage'),
      }),
    );
  };

  updateStage = (id: TMStageId, brand: Partial<TMStageResponse>) => {
    return TMStageAPI.updateStage(id, brand).pipe(
      this.ordersRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_order_stage'),
      }),
    );
  };

  deleteStage = (stageId: TMStageId) => {
    return showDeleteConfirmation('Delete Stage', `Do you really want to remove this stage?`).pipe(
      switchMap(() => TMStageAPI.deleteStage(stageId)),
      this.ordersRepo.ops.removeOne(() => stageId),
      handleMessage({
        type: requestMessage('delete_order_stage'),
      }),
    );
  };

  updateStatus = (id: TMStageId) => {
    return TMStageAPI.updateStatus(id).pipe(
      this.ordersRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_order_stage'),
      }),
    );
  };
}
